import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.css'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyAPt5dIHWWUPUfHMpC5Kk1W10KP2bte_JI",
  authDomain: "cortex-condo.firebaseapp.com",
  projectId: "cortex-condo",
  storageBucket: "cortex-condo.appspot.com",
  messagingSenderId: "372433241357",
  appId: "1:372433241357:web:f1149f9f73eb7d77221c44",
  measurementId: "G-CBP56KW8B5"
}

firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')